import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

interface FooterLink {
  label: string;
  href?: string;
  to?: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

interface FooterProps {
  logo?: {
    src?: string;
    text: string;
  };
  tagline?: string;
  sections: FooterSection[];
  copyright?: string;
}

const Footer: React.FC<FooterProps> = ({
  logo = { text: 'Orca Labs' },
  tagline = 'AI & data for Retail and CPG.',
  sections,
  copyright = '© 2024 Orca Labs. All rights reserved.',
}) => {
  return (
    <footer className="consulting-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              {logo.src && (
                <img src={logo.src} alt={logo.text} height="40" width="40" />
              )}
              <span className="logo-text">{logo.text}</span>
            </div>
            {tagline && <p className="footer-tagline">{tagline}</p>}
          </div>
          {sections.map((section, index) => (
            <div key={index} className="footer-section">
              <h4>{section.title}</h4>
              <ul>
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.to ? (
                      <Link to={link.to}>{link.label}</Link>
                    ) : link.href ? (
                      <a href={link.href}>{link.label}</a>
                    ) : (
                      <span>{link.label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <p>{copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

